import * as actions from '../utils/Constants';
import { getProgramGrants } from './Program';
import { getGrants } from './Grants';
const api = `${process.env.REACT_APP_API_HOST}api/grant/`;

export const getGrant = (id) => {
    return {
        type: actions.GET_GRANT,
        payload: fetch(api + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        }).then(res => {
            return res.json();
        })
    }
}

export const updateGrant = (grant, programId) => {
    return dispatch => dispatch({
        type: actions.UPDATE_GRANT,
        payload: fetch(
            programId ? `${api}?programId=${programId}` : api,  // avoid adding undefined param
            {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(grant),
            }
        ).then(res => {
            if (programId) {
                dispatch(getProgramGrants(programId)); // refresh program grants only if relevant
            }
            else {
                dispatch(getGrants())
            }
            return res.json(); // always return the response data
        })
    });
};


export const setField = (currentSessionId, field, value) => ({
    type: actions.SET_GRANT_FIELD,
    currentSessionId,
    field,
    payload: value
});
